import React from "react";
import { usePutSuppressionFindSearchMutation } from "@tiny/api";
import { SuppressionSearchResultView } from "@tiny/api";
import { useMessages } from "@tiny/components";
import {
  extractBackendError,
  getErrorMessage,
} from "@tiny/components/src/utils/errorUtils";

export function useFindEmailDialog() {
  const { showErrorMessage } = useMessages();

  const [email, setEmail] = React.useState("");
  const [results, setResults] = React.useState<
    SuppressionSearchResultView[] | null
  >(null);

  const mutation = usePutSuppressionFindSearchMutation({
    onSuccess: (data) => {
      setResults(data?.searchSuppressed ?? []);
    },
    onError: async (e: any) => {
      const be = await extractBackendError(e?.response);
      showErrorMessage(getErrorMessage(be));
    },
  });

  const onSearch = React.useCallback(() => {
    if (!email.trim()) return;
    mutation.mutate({ email: email.trim() });
  }, [email, mutation]);

  const onReset = React.useCallback(() => {
    setEmail("");
    setResults(null);
  }, []);

  return {
    email,
    setEmail,
    results,
    isLoading: mutation.isLoading,
    onSearch,
    onReset,
  };
}
